/**
 * The public shape of the trial offer, isomorphic and DB-free, for chrome
 * that renders on every public page (the announcement bar above the header).
 * Same trick as `gateways/availability.ts`: the server reads the raw env during
 * SSR and `__root.tsx` inlines the result; the client reads it back.
 */

import {
  CARD_TRIAL_DAYS,
  TRIAL_ALLOWANCE_BYTES,
  type TrialKind,
} from '@/lib/billing/trial'

export interface PublicTrialOffer {
  kind: TrialKind
  days: number
  allowanceBytes: number
}

declare global {
  interface Window {
    __TRIAL_OFFER__?: PublicTrialOffer | null
  }
}

function flagOn(raw: string | undefined, fallback: boolean): boolean {
  if (raw === undefined || raw === '') return fallback
  return !['false', '0', 'no', 'off'].includes(raw.trim().toLowerCase())
}

/** The offer as the SERVER sees it: the card trial, while its switch is on. */
export function serverPublicTrialOffer(): PublicTrialOffer | null {
  if (!flagOn(process.env.TRIAL_ENABLED, true)) return null
  return {
    kind: 'card',
    days: CARD_TRIAL_DAYS,
    allowanceBytes: TRIAL_ALLOWANCE_BYTES,
  }
}

export function publicTrialOffer(): PublicTrialOffer | null {
  if (import.meta.env.SSR) return serverPublicTrialOffer()
  return window.__TRIAL_OFFER__ ?? null
}
